export enum FileStatus {
  INIT = "INIT",
  INPROGRESS = "INPROGRESS",
  SUBMIT = "SUBMIT",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export enum ErrorButtonActionType {
  SELECTFILE = "SELECTFILE",
  DOWNLOAD = "DOWNLOAD",
  CANCEL = "CANCEL",
}
